<template>
  <v-dialog v-model="showNewOrder" width="1200" persistent>
    <v-card>
      <div id="holder"></div>

      <v-banner sticky class="primary custom-padding py-0">
        <v-row class="text-left pb-0">
          <v-col cols="12" md="3" lg="2" class="py-0 pt-5">
            <span class="white--text custom-title">Create New Order</span>
          </v-col>
          <v-col cols="12" md="4" lg="4" class="pb-0">
            <ValidationProvider
              name="Wholesaler"
              rules="required"
              v-slot="{ errors }"
            >
              <v-autocomplete
                :items="wholesalerData"
                label="Wholesaler"
                outlined
                placeholder="Select wholesaler"
                :error-messages="
                  wholesalerAccount === 0 ? 'Wholesaler is required' : errors
                "
                :error="wholesalerAccount === 0"
                :item-text="setCompany"
                item-value="accountNumber"
                dense
                dark
                v-model="wholesalerAccount"
                :readonly="wholesalerData.length === 1"
                :disabled="isOriginal"
                @change="wholesalerChanged"
              ></v-autocomplete>
            </ValidationProvider>
            <v-spacer></v-spacer>
          </v-col>
        </v-row>
      </v-banner>

      <v-card-text class="pb-0" ref="calcHeight">
        <v-row>
          <v-col cols="12" md="8" class="pt-2">
            <div id="holder"></div>
            <qualification-form
              ref="qualification"
              :isOriginal="isOriginal"
              @showResultSection="showResultSection"
              @toggleInput="toggleInput"
              @changed="changed"
            ></qualification-form>
            <qualification-result
              ref="qualificationResult"
              class="mt-2"
              v-if="showResult"
              :isOriginal="isOriginal"
              :showButtons="false"
              :hideOtherButtons="false"
              :showLocIdInput="showLocIdInput"
              :queryAddress="queryAddress"
              :hasMultipleLocId="hasMultipleLocId"
              @serviceability="setServiceability"
              @hideBaseOffer="hideBaseOffer"
            ></qualification-result>
          </v-col>
          <v-col cols="12" md="4">
            <enhanced-sq></enhanced-sq>
          </v-col>
        </v-row>
      </v-card-text>

      <ValidationObserver ref="observer" v-slot="{ dirty, invalid }">
        <v-card-text>
          <v-divider class="mt-4 mb-8"></v-divider>

          <order-details
            ref="orderDetails"
            :newOrder="newOrder"
            :ntd="ntd"
            :unid="unid"
            :wholesalerAccount="
              wholesalerAccount ? wholesalerAccount.accountNumber : 0
            "
            @createOffer="createOffer"
            @backToOffer="backToOffer"
            @updateContact="updateContact"
            @deliverToCustomer="setDeliveryDetails"
            @displayOffer="displayOffer"
            @updateWorkforce="updateWorkforce"
          ></order-details>
        </v-card-text>

        <div class="fixed-bar rtl primary py-4">
          <v-btn @click="close()" class="mr-4">Close</v-btn>
          <v-btn
            class="mr-3"
            :disabled="isOriginal"
            @click="beforeCreateOrder()"
            >Create</v-btn
          >
        </div>
      </ValidationObserver>
    </v-card>
  </v-dialog>
</template>

<script>
import { Order } from "@/models/Order";
export default {
  name: "CreateOrder",
  props: {
    showNewOrder: { type: Boolean, required: true },
  },
  data: () => ({
    newOrder: new Order(),
    details: {},
    ntd: [],
    unid: [],
    queryAddress: [],
    showResult: false,
    showLocIdInput: false,
    hasMultipleLocId: true,
    newDate: null,
    showDetails: false,
    wholesalerAccount: 0,
    isServiceable: false,
    workforceClass: ["23", "24", "30"],
    isContactValid: false,
    deliveryDetails: {
      address: "",
      name: "",
      company: "",
    },
    isOfferVisible: false,
    primaryAccessTechnology: "",
    fttc: ["30", "31", "32", "33", "34"],
    fttb: ["10", "11", "12", "13"],
  }),
  computed: {
    invalidProductErr() {
      let vm = this;
      return vm.$route.path === "/"
        ? `${vm.primaryAccessTechnology} is not included in our services. Can't proceed with the order.`
        : `${vm.primaryAccessTechnology} is not included in our services.`;
    },
    isFttb() {
      let vm = this;
      if (vm.fttb.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    isFttc() {
      let vm = this;
      if (vm.fttc.includes(vm.formattedSQResult.serviceabilityClass))
        return true;
      else return false;
    },
    disableCreate() {
      let vm = this;
      if (vm.isCustomWorkforce) {
        return (
          !vm.showDetails ||
          !vm.isServiceable ||
          !vm.isContactValid ||
          !vm.isOfferVisible
        );
      } else return !vm.showDetails || !vm.isServiceable || !vm.isOfferVisible;
    },
    isCustomWorkforce() {
      let vm = this;
      return vm.workforceClass.includes(
        vm.formattedSQResult.serviceabilityClass
      );
    },
    wholesalerData: function () {
      let vm = this;
      let data = null;

      if (vm.impersonating !== null) {
        if (vm.isUserMember) {
          data = vm.wholesalers;
          vm.wholesalerAccount = 0;
        } else {
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.user.email
          );
          vm.wholesalerAccount = data[0].accountNumber;
        }
      } else {
        if (vm.isAdmin) {
          data = vm.wholesalers;

          if (vm.isOriginal)
            vm.selectedWholeSaler = vm.wholesalers.filter(
              (x) =>
                x.accountNumber === vm.selectedOrder.wholesalerAccountNumber
            ).wholesalerAccountNumber;
          else vm.wholesalerAccount = 0;
        } else {
          data = vm.wholesalers.filter(
            (x) => x.oneLoginEmail === vm.user.email
          );
          vm.wholesalerAccount = data[0].accountNumber;
        }
      }

      return data;
    },
  },
  methods: {
    updateWorkforce(value) {
      let vm = this;
      vm.newOrder.installationWorkforce = value;
    },
    checkLayer() {
      const vm = this;
      if (vm.wholesalerAccount && vm.orderType === "nbn") {
        vm.retrieveFeatures(vm.wholesalerAccount);
      }
    },
    retrieveFeatures(accountNumber) {
      let vm = this;
      vm.getFeatures(accountNumber);
    },
    wholesalerChanged() {
      let vm = this;
      vm.checkLayer();
    },
    displayOrder(item, sqResponse) {
      let vm = this;
      vm.showResult = true;
      vm.showLocIdInput = true;

      vm.$nextTick(() => {
        vm.$refs.qualification.streetAddress = item.address;
        vm.$refs.qualificationResult.displayOrder(item, sqResponse);
        vm.$refs.orderDetails.displayOrder();
      });
    },
    displayOffer() {
      let vm = this;
      vm.isOfferVisible = true;
      if (!vm.$refs.orderDetails.showInstallationWorkforce)
        vm.isContactValid = true;
      else vm.isContactValid = false;
    },
    hideBaseOffer() {
      let vm = this;
      vm.$refs.orderDetails.showMore = false;
      vm.isOfferVisible = false;
      vm.isServiceable = false;
    },
    setDeliveryDetails(value) {
      let vm = this;
      if (value) {
        vm.newOrder.deliveryAddress = vm.fullAddress.formatted_address;
        vm.newOrder.deliveryContactName = `${vm.newOrder.customerFirstName} ${vm.newOrder.customerLastName}`;
      } else {
        vm.newOrder.deliveryAddress = "";
        vm.newOrder.deliveryContactName = "";
      }
    },
    updateContact(techDetails) {
      let vm = this;
      vm.newOrder.contactFirstName = techDetails.firstName;
      vm.newOrder.contactLastName = techDetails.lastName;
      vm.newOrder.contactNumber = techDetails.number;
      vm.newOrder.contactEmail = techDetails.email;
      vm.updateOfferContact(techDetails);
      vm.isContactValid = true;
    },
    beforeCreateOrder() {
      const vm = this;
      let errorMessage = "";
      if (vm.disableCreate) {
        errorMessage = "Please check missing fields";
      } else {
        errorMessage = "";
      }

      vm.$refs.observer.validate().then((result) => {
        if (result && !errorMessage.length) {
          vm.createOrder();
        } else {
          vm.setHttpResponse({
            text: errorMessage,
            color: "error",
          });
        }
      });
    },
    createOrder() {
      let vm = this;
      vm.createNewOrder(vm.customizedOfferResult).then((data) => {
        // if (data.success) {
        if (data !== null) {
          setTimeout(() => {
            vm.setCustomizedOffer({});
            vm.newOrder = new Order();
            vm.$emit("orderSubmitted");
            vm.setHttpResponse({
              text: `Order submitted and saved.`,
              color: "success",
            });
          }, 500);
        } else {
          setTimeout(() => {
            vm.setHttpResponse({
              text: `Failed. ${data.message}`,
              color: "error",
            });
          }, 500);
        }
      });
    },
    setCompany(details) {
      let text = "";
      if (details.company !== "" && details.company !== null)
        text = details.company;
      else if (details.name !== "" && details.name !== null)
        text = details.name;
      return text;
    },
    setWholesaler() {
      let vm = this;
      vm.getWholesalers()
        .then((data) => {
          if (!vm.isUserMember || data.length === 1) {
            vm.wholesalerAccount = data[0].accountNumber;
          } else vm.wholesalerAccount = 0;
        })
        .catch(() => {});
    },
    createOffer(order) {
      let vm = this;
      let payload = {
        locationId: vm.locationID,
        customerAuthDate: new Date(),
        orderType: order.orderType.value.toUpperCase(),
        requestedSpeed: order.avcdBandwidthProfile.value
          ? order.avcdBandwidthProfile.value
          : order.avcdBandwidthProfile,
        contractLength: order.contractTermLength,
        customer: {
          firstName: order.customerFirstName,
          lastName: order.customerLastName,
          contactNo: order.customerContactNumber,
          email: order.customerContactEmail,
        },
        ticketId: order.customerReference,
        customerAuthReference: order.customerAuthReference,
        operatorContactEmail: vm.user.email,
        operatorContactNumber: order.contactNumber,
        operatorContactName: `${order.contactFirstName} ${order.contactLastName}`,
        serviceId: "",
        accessLoopId: "N/A",
        fnn: order.fnn,
        wholesalerAccount: vm.wholesalerAccount,
      };

      vm.createCustomisedOffer(payload).then((data) => {
        if (data.data) {
          data.data.baseOffer.serviceFeatures.forEach((x) => {
            switch (x.featureKey) {
              case "NBN_SERVICE_SPEC:LOCATION_ID":
                vm.newOrder.locationId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:AVCD_BANDWIDTH_PROFILE":
                vm.newOrder.avcdBandwidthProfile =
                  x.value.value === "12/1"
                    ? "Entry Level Bundle"
                    : x.value.value;
                break;
              case "NBN_SERVICE_SPEC:RSP_DELIVERY_CIRCUIT":
                vm.newOrder.rspDeliveryCircuit = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_FIRST_NAME":
                vm.newOrder.customerFirstName = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_LAST_NAME":
                vm.newOrder.customerLastName = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_CONTACT_NUMBER":
                vm.newOrder.customerContactNumber = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_AUTH_DATE":
                vm.newOrder.customerAuthDate = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:UNIDSL_POTS_INTERCONNECT":
                vm.newOrder.unidslPotsInterconnect = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:SERVICE_CLASS":
                vm.newOrder.serviceClass = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_REFERENCE":
                vm.newOrder.customerReference = x.value.value;
                if (vm.isAdmin || vm.isUserMember)
                  vm.newOrder.customerAuthReference = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CUSTOMER_AUTH_REFERENCE":
                if (!vm.isAdmin || !vm.isUserMember)
                  vm.newOrder.customerAuthReference = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CENTRAL_SPLITTER":
                vm.newOrder.centralSplitter = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:SPECIAL_INSTRUCTION":
                vm.newOrder.specialInstruction = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:PORTING_NUMBER":
                vm.newOrder.portingNumber = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CPI_ID":
                vm.newOrder.cpiId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:NTD_ID":
                vm.newOrder.ntdId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:INSTALLATION_WORKFORCE":
                if (vm.isCustomWorkforce)
                  vm.newOrder.installationWorkforce = "";
                else if (vm.isFttc) {
                  if (
                    vm.sqResult.parameters.parameterGroup &&
                    vm.sqResult.parameters.parameterGroup.length > 0
                  ) {
                    let cpi = vm.sqResult.parameters.parameterGroup.filter(
                      (x) => x.groupName === vm.newOrder.cpiId
                    );

                    if (cpi && cpi.length > 0) {
                      let cpiClass = cpi[0].parameter.filter(
                        (x) => x.name === "ServiceabilityClass"
                      )[0].value;

                      if (vm.fttc.includes(cpiClass)) {
                        if (cpiClass === "31" || cpiClass === "32")
                          vm.newOrder.installationWorkforce =
                            "Professional Install";
                        else vm.newOrder.installationWorkforce = "";
                      }
                    }
                  }
                } else if (vm.isFttb) {
                  if (vm.hasFreePort)
                    vm.newOrder.installationWorkforce = "Professional Install";
                  else vm.newOrder.installationWorkforce = "";
                } else vm.newOrder.installationWorkforce = "Not Required";
                break;
              case "NBN_SERVICE_SPEC:CONTACT_NUMBER":
                vm.newOrder.contactNumber = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CONTACT_EMAIL":
                vm.newOrder.contactEmail = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:DELIVERY_INSTRUCTIONS":
                vm.newOrder.deliveryInstructions = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:CSA_ID":
                vm.newOrder.csaId = x.value.value;
                break;
              case "NBN_SERVICE_SPEC:UNID_PORT_ID":
                vm.newOrder.unidPortId = x.value.value;
                break;
            }
          });

          // if (data.data.ordeR_TYPE === "SERVICE TRANSFER") {
          //   vm.newOrder.specialInstruction = "";
          //   vm.newOrder.portingNumber = "";
          // }

          vm.$refs.orderDetails.showMore = true;
          vm.isOfferVisible = true;
          vm.showDetails = true;
        }
        vm.$refs.orderDetails.checkRequired();
      });
    },
    backToOffer() {
      let vm = this;
      vm.showDetails = false;
      vm.newOrder.customerAuthDate = "";
      vm.newOrder.unidslPotsInterconnect = "";
      vm.newOrder.cpiId = "";
      vm.newOrder.ntdId = "";
      vm.newOrder.unidPortID = "";
      vm.newOrder.installationWorkforce = "";
      vm.newOrder.portingNumber = "";
      vm.newOrder.specialInstruction = "";
      vm.newOrder.deliveryInstructions = "";
    },
    close() {
      let vm = this;
      document.getElementById("holder").scrollIntoView({ behavior: "smooth" });
      vm.$refs.observer.reset();
      vm.$refs.qualification.selected = "Physical Address";
      vm.newOrder = new Order();
      vm.setSqResult({});
      vm.reset5gSq();
      vm.resetFeature();

      if (vm.impersonating !== null) {
        if (vm.isUserMember) vm.wholesalerAccount = 0;
      } else {
        if (vm.isAdmin) vm.wholesalerAccount = 0;
      }

      vm.$refs.qualification.streetAddress = "";
      vm.$refs.qualification.result = {
        suburb: "",
        state: "",
        postCode: "",
        streetAddress: "",
      };
      vm.queryAddress = [];
      vm.showResult = false;
      vm.hasMultipleLocId = false;
      vm.$refs.orderDetails.showMore = false;
      vm.$emit("close");
      vm.setOriginal(false);
      vm.resetProduct();
    },
    showResultSection(data) {
      let vm = this;
      vm.queryAddress = data.queryAddress;
      if (data.queryAddress.length === 1 && data.queryAddress.length !== 0) {
        vm.setLocationID(data.queryAddress[0].locationId);
        vm.hasMultipleLocId = false;
        vm.serviceQualification(data.queryAddress[0]).then((result) => {
          result.data.parameters.parameter.forEach((x) => {
            if (x.name === "PrimaryAccessTechnology")
              vm.primaryAccessTechnology = x.value;
          });

          vm.getExcludedProducts(vm.primaryAccessTechnology).then(() => {
            if (vm.isProductExcluded) {
              vm.setHttpResponse({
                text: vm.invalidProductErr,
                color: "error",
              });
            }
          });

          vm.setServiceability(result.data.serviceability);
          vm.setFormattedSQResult(result.data);
          vm.showResult = true;
          this.$nextTick(() => {
            vm.$refs.qualificationResult.result = result.data;
          });
        });
      } else vm.showResult = true;
    },
    toggleInput(state) {
      let vm = this;
      vm.showResult = state;
      vm.showLocIdInput = state;
    },
    setNewDate(date) {
      let vm = this;
      vm.setNewDate = date;
    },
    changed() {
      let vm = this;
      vm.showResult = false;
      vm.hasMultipleLocId = true;
      vm.resetFormattedSQResult();
      vm.$refs.orderDetails.showMore = false;
    },
    setServiceability(value) {
      let vm = this;
      if (value) {
        if (value.includes("Rejected")) vm.isServiceable = false;
        else vm.isServiceable = true;
      } else {
        if (vm.sqResult.serviceability.includes("Rejected"))
          vm.isServiceable = false;
        else vm.isServiceable = true;
      }
    },
  },
  watch: {
    details: function () {
      let vm = this;
      let hasLotNumber = false;

      if (vm.details.address.formattedAddress.includes("Lot"))
        hasLotNumber = true;

      let streetAddress = vm.details.address.formattedAddress.split(",");

      vm.$nextTick(() => {
        vm.$refs.qualification.result = {
          suburb: vm.details.address.suburb,
          state: vm.details.address.stateOrProvince,
          postCode: vm.details.address.postcode,
          streetAddress: hasLotNumber
            ? streetAddress[0] + ", " + streetAddress[1]
            : streetAddress[0],
        };
        vm.$refs.qualification.withData = vm.details.withData;
      });
    },
    locationID: function () {
      let vm = this;
      vm.newOrder = new Order();
      vm.resetProduct();
    },
    wholesalerAccount: function () {
      let vm = this;
      if (vm.wholesalerAccount) {
        if (
          typeof vm.$refs.orderDetails !== "undefined" &&
          vm.$refs.orderDetails.showMore
        )
          vm.updateCustomizedOffer({
            field: "Wholesaler",
            value: vm.wholesalerAccount,
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .custom-padding .v-banner__wrapper {
  padding-bottom: 0px !important;
}

.custom-title {
  font-size: 20px;
  font-weight: bold;
}

.rtl {
  direction: rtl;
}

.fixed-bar {
  width: 100%;
  position: sticky;
  bottom: -1px;
}

::v-deep
  .fixed-bar
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #f5f5f5 !important;
}
</style>
